import { Component, computed, OnInit, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { Enums } from '../../../shared/enums';
import { IMPORTS } from './_imports';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class FooterComponent implements OnInit {
    // #region [props]
    yearComplement: string;
    // #endregion

    // #region [signals]
    $isLandingPage = signal(false);
    $env = signal(null as string);
    $environment = signal(null as string);
    // #endregion

    // #region [computeds]
    $shouldHideEnvironment = computed(() => this.$env()?.toLowerCase() == 'prd' || this.$isLandingPage());
    // #endregion

    constructor(
        private cookieService: CookieService,
        private titleService: Title
    ) {
        this.$isLandingPage.set(window?.location?.pathname == Enums.PagesPaths.LandingPage);
        this.yearComplement = (new Date()).getFullYear() > 2021 ? `-${(new Date()).getFullYear()} ` : "";
    }

    ngOnInit() {
        this.$env.set(atob(this.cookieService.get('prodest-eflow-env')).toLowerCase());

        switch (this.$env()) {
            case 'loc':
                this.$environment.set(Enums.Messages.EnvironmentLocalhost);
                this.titleService.setTitle(`${this.titleService.getTitle()} [L]`);
                break;

            case 'des':
                this.$environment.set(Enums.Messages.EnvironmentDevelopment);
                this.titleService.setTitle(`${this.titleService.getTitle()} [D]`);
                break;

            case 'hom':
                this.$environment.set(Enums.Messages.EnvironmentStaging);
                this.titleService.setTitle(`${this.titleService.getTitle()} [H]`);
                break;

            case 'tre':
                this.$environment.set(Enums.Messages.EnvironmentLearning);
                this.titleService.setTitle(`${this.titleService.getTitle()} [T]`);
                break;
        }
    }

    // #region [===== private methods =====]
    // #endregion
}
